import React from 'react';
import { Html } from '@react-three/drei';

/**
 * Cursor-Annotation (Distanz/Winkel neben der Maus - Rhino-Style).
 * Zeigt die Distanz und den Winkel vom letzten Punkt zur aktuellen
 * Mausposition an.
 */
export function CursorAnnotation({ lastPoint, mousePosition, orthoMode, activeTool }) {
  if (!lastPoint || !mousePosition) return null;
  if (activeTool !== 'point' && activeTool !== 'wall' && activeTool !== 'space' && activeTool !== 'arc') return null;

  // Ortho-Berechnung
  let targetX = mousePosition.x;
  let targetY = mousePosition.y;

  if (orthoMode) {
    const dx = Math.abs(mousePosition.x - lastPoint.x);
    const dy = Math.abs(mousePosition.y - lastPoint.y);
    if (dx > dy) {
      targetY = lastPoint.y;
    } else {
      targetX = lastPoint.x;
    }
  }

  const dx = targetX - lastPoint.x;
  const dy = targetY - lastPoint.y;
  const distance = Math.sqrt(dx * dx + dy * dy);
  const angle = Math.atan2(dy, dx) * (180 / Math.PI);

  // Text formatieren
  const distText = (distance / 1000).toFixed(2) + ' m';
  const angleText = angle.toFixed(0) + '°';

  return (
    <Html
      position={[targetX + 250, targetY + 150, 20]}
      style={{
        pointerEvents: 'none',
        userSelect: 'none',
      }}
    >
      <div className="bg-gray-900/90 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap font-mono">
        <span className="text-green-400 font-bold">{distText}</span>
        <span className="text-gray-400 mx-1">∠</span>
        <span className="text-yellow-400">{angleText}</span>
      </div>
    </Html>
  );
}

export default CursorAnnotation;
